
import { useEffect, useState } from 'react';
import {   ApplePay,
  GooglePay,
  CreditCard,
  PaymentForm, } from 'react-square-web-payments-sdk';
import { SEND_SINGLE_SQUARE_TRANSACTION } from '../graphql/mutations/square';
import { useMutation } from '@apollo/client';
import { Col, Row } from 'reactstrap';

function SquarePayment() {
  const [loading, setLoading] = useState(false);
  const [theCardToken, setCardToken] = useState();

  const styles = {
    input: {
      fontSize: '16px',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      display: 'block', // Make sure each input is a block element
      width: '100%', // Take full width of the container
      // marginBottom: '10px', // Add some space between fields
    },
    ':focus': {
      borderColor: 'blue',
    },
    '.message': {
      color: 'red',
      fontSize: '12px',
    },
    '.input-container': {
      marginBottom: '10px',
    },
    '.input-label': {
      fontWeight: 'bold',
      marginBottom: '5px',
    },
  };
  
  let cardToken;

  const [sendSingleSquareTransaction] = useMutation(SEND_SINGLE_SQUARE_TRANSACTION);

  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage({ type: 'FROM_IFRAME', payload: { data: data, action: action } }, process.env.REACT_APP_WOWCLOUD_PARENT + '/checkout/ed00261a-87f6-4744-8915-e2d4f40b1111'); //Parent
  }

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent
  
    console.log('event:', event);
      const { type, payload } = event.data;

      if (type === 'FROM_PARENT') {
        if(payload.action === "SendBillingData"){
          const serverPayload = {
            token: theCardToken.token,
            paymentdata: {
              firstname: payload.data.firstname,
              lastname: payload.data.lastname,
              address: payload.data.address1,
              address2: payload.data.address2,
              city: payload.data.city,
              state: payload.data.state,
              zip: parseInt(payload.data.zip),
              phone: payload.data.phone,
              email: payload.data.email,
              country: "US",
              price: parseInt(payload.data.price),
              expMonth: parseInt(theCardToken.details.card.expMonth),
              expYear: parseInt(theCardToken.details.card.expYear),
              lastFour: parseInt(theCardToken.details.card.last4),
              processorTransactionId: theCardToken.token,
              bin: "",
              paymentid: payload.data.paymentid,
              productid: payload.data.productid,
              refid: payload.data.refid,
              shortdescription: payload.data.shortdescription,
              existingcustomer: payload.data.existingcustomer,
              referral: payload.data.referral,
            }
          }

          SendSingleTransaction(serverPayload)
        }
        else if(payload.action == "Reset"){
          setLoading(false);
        }
      }
    };
  
    window.addEventListener('message', handleIframeMessage);
  
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [theCardToken]);

  const SendSingleTransaction = (serverPayload) => {
    sendSingleSquareTransaction({ variables: {token: serverPayload.token, paymentdata: serverPayload.paymentdata}})
    .then((tres) => {
      if(tres.data.sendSingleSquareTransaction.status){
        SendIFrameMessage(tres.data.sendSingleSquareTransaction.data, "TransactionSuccess")
        // setLoading(false);
      }
      else{
        if(tres.data.sendSingleSquareTransaction.error === "CardValidationRequired"){
          SendIFrameMessage(tres.data.sendSingleSquareTransaction.error, "CardValidationRequired")
          setLoading(false);
        }
        else{
          SendIFrameMessage(tres.data.sendSingleSquareTransaction.error, "TransactionError")
          setLoading(false);
        }
      }
    })
    .catch((err) => {
      // console.log("ERROR2", err)
    })
    .finally(() =>{
      //TODO: Set loading
    })
  }

  const onClick = () =>{
    setLoading(true);
  }

    return (
      <div className="mwContainer">
        {loading &&
          <Row>
            <Col md = "12">
              <h1>Processing ...</h1>
            </Col>
          </Row>
        }

        {!loading &&
          <PaymentForm
            applicationId={process.env.REACT_APP_SQUARE_APPLICATIONID}
            cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
              // cardToken = token;
              setCardToken(token);
              setLoading(true)
              setTimeout(() => {
                SendIFrameMessage(null, "SendBillingData");
              }, 1000)
            }}

            locationId={process.env.REACT_APP_SQUARE_LOCATION}
          >
  
            <CreditCard
            includeInputLabels
            buttonProps={{
              isLoading: loading,
              onClick: onClick,
            }} 
            styles={styles}
            />
            
          </PaymentForm>
        } 
      </div>
  )
}

export default SquarePayment;